/* eslint-disable no-plusplus */
import { type Table } from '@tanstack/react-table'
import { useMemo } from 'react'

export interface UseColumnSizeVarsArgs<TData> {
  horizontalScrollingAreaWidth: number | null
  table: Table<TData>
}

export const useColumnSizeVars = <TData>({
  horizontalScrollingAreaWidth,
  table,
}: UseColumnSizeVarsArgs<TData>) => {
  const { columnSizingInfo, columnSizing, columnVisibility } = table.getState()
  const flatColumns = table.getAllFlatColumns()

  const columnSizeVars = useMemo(() => {
    const headers = table.getFlatHeaders()

    const colSizes: { [key: string]: number } = {}

    for (let i = 0; i < headers.length; i++) {
      const header = headers[i]
      colSizes[`--header-${header.id}-size`] = header.getSize()
      colSizes[`--col-${header.column.id}-size`] = header.column.getSize()
    }

    const tableSize = table.getTotalSize()

    colSizes[`--table-size`] = tableSize

    const tableLastColumnSize = horizontalScrollingAreaWidth
      ? horizontalScrollingAreaWidth - tableSize
      : 0

    const positiveLableLastColumnSize = tableLastColumnSize < 0 ? 0 : tableLastColumnSize

    colSizes[`--header-last-column-size`] = positiveLableLastColumnSize
    colSizes[`--col-last-column-size`] = positiveLableLastColumnSize

    return colSizes
  }, [columnSizingInfo, columnSizing, columnVisibility, flatColumns, horizontalScrollingAreaWidth])

  return columnSizeVars
}
